// @flow

import type { FetchOpts } from './fetch'

import HttpClient from 'frame/net/HttpClient'
import { getCookie } from 'frame/core/cookie'

function getEnvValue (key): string {
  return process.env[key] || ''
}

const relativeApiClient = new HttpClient('/api')

const mClient = new HttpClient(getEnvValue('host.mApi'))
const operatorClient = new HttpClient(getEnvValue('host.operatorApi'))

const abroadClient = new HttpClient(
  getEnvValue('host.abroadApi'),
  (opts: FetchOpts): FetchOpts => {
    const token = getCookie('__token__') || getCookie('pcFlag')
    if (token) {
      opts.headers = { ...opts.headers, token: decodeURIComponent(token) }
    }
    return opts
  }
)

export { relativeApiClient, mClient, abroadClient, operatorClient }



// WEBPACK FOOTER //
// ./src/frame/net/clientFactory.js